<template>
    <div>
        <form-with-loader :form="form" @error="setServerError" @success="refresh" class="login-form">
            <h3 class="welcome-msg">Welcome Back :)</h3>
            <label>
                <div class="label-text email-label">Email</div>
                <error :error="form.validator.getError('email')"></error>
                <input
                        v-model="form.email"
                        type="email"
                        @focus="shrinkLabel('email-label', $event)"
                        @blur="growLabel('email-label', $event)">
            </label>
            <label>
                <div class="label-text password-label">Password</div>
                <error :error="form.validator.getError('password')"></error>
                <input
                        v-model="form.password"
                        type="password"
                        @focus="shrinkLabel('password-label', $event)"
                        @blur="growLabel('password-label', $event)">
                <span class="error" v-if="serverError">For serious. Your email or password are incorrect</span>
            </label>


            <template slot="button-text">Tally Ho</template>

        </form-with-loader>
    </div>
</template>

<script>
    import VuetifulForm     from "vuetiful-forms/src/components/VuetifulForm";
    import Error          from "vuetiful-forms/src/components/Error";
    import LoginForm      from "../../Forms/LoginForm";
    import labelAnimation from "../../../../Lib/Mixins/labelAnimation";
    import refresh        from "../../../../Lib/Mixins/refresh";
    import FormWithLoader from "../../../../App/Views/Components/FormWithLoader";
    import serverError    from "../../../../Lib/Mixins/serverError";

    export default {
        name      : "Login",
        mixins    : [labelAnimation, refresh, serverError],
        components: { FormWithLoader, Error, VuetifulForm },
        data() {
            return {
                form: new LoginForm(),
            }
        },
    }
</script>

<style scoped>

</style>
